module.exports = __webpack_public_path__ + "static/media/fr.348d4a7c.svg";